var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("slk-g-indicator slk-ind-s-" + _vm.size + " slk-ind-v-" + _vm.variant + " " + _vm.indicatorStyle + " " + (_vm.disabled ? 'disabled' : ''))},[_vm._v("\n  "+_vm._s(_vm.size != "large" ? "" : _vm.counter)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }